import { render, staticRenderFns } from "./27100006.vue?vue&type=template&id=1c4b8966&scoped=true&"
import script from "./27100006.vue?vue&type=script&lang=js&"
export * from "./27100006.vue?vue&type=script&lang=js&"
import style0 from "./27100006.vue?vue&type=style&index=0&id=1c4b8966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b8966",
  null
  
)

export default component.exports